
// Split Lines
export function splitLines(containers) {

    // Each Container of Paragraph
    containers.forEach((container) => {
        // Select children of parent
        var spans = container.children,
        top = 0,
        tmp = '';
        
        container.innerHTML = container.textContent.replace(/\S+/g, '<n>$&</n>');	 
        
        // Define closing tag
        let closingtag = '</span>';
        
        // Loop per line
        for (let i = 0; i < spans.length; i++) {
        // Define opening tag with animation order
        let opentag = '<span style="--animation-order:' + (i + 1) + ';">'; 
        var rect = spans[i].getBoundingClientRect().top;
        if (top < rect) tmp += closingtag + opentag;
        top = rect;
        tmp += spans[i].textContent + ' ';
        }

        container.innerHTML = tmp += closingtag;

    });
}
  
